@if (store.displayIncoterm()) {
    <div class="px-3">
        <div class="row">
            <div class="col">
                <strong>{{ 'Incoterm' | translate }}</strong>
            </div>
        </div>
        @if (editable()) {
            <div class="row align-items-center mx-auto">
                <div class="col-auto ps-0">
                    <iim-advanced-autocomplete
                        [value]="store.selectedIncoterm()"
                        [showLabel]="false"
                        [deletable]="false"
                        [placeholder]="'Incoterm wählen' | translate"
                        (valueSelected)="onIncotermSelected($event)"
                    >
                        @for (incoterm of store.incoterms(); track incoterm.shortCode) {
                            <iim-autocomplete-option [value]="incoterm">
                                {{ incoterm.valueDisplay }}
                            </iim-autocomplete-option>
                        }
                    </iim-advanced-autocomplete>
                </div>

                @if (store.canRemoveIncoterm()) {
                    <div class="col-auto p-0">
                        <button
                            [matTooltip]="'Incoterm entfernen' | translate"
                            mat-icon-button
                            color="warn"
                            (click)="deleteCurrent($event)"
                        >
                            <em class="fas fa-trash"></em>
                        </button>
                    </div>
                }
            </div>
        } @else {
            <div class="row align-items-center mx-auto">
                @if (store.selectedLabel()) {
                    <div class="col-auto ps-0">
                        {{ store.selectedLabel() }}
                    </div>
                }
            </div>
        }
    </div>
}
